<template>
  <slot v-if="type === 'luxury'" name="luxury">
    <img src="@/assets/images/benefit/H_rate_icon.png" alt="" />
  </slot>
  <slot v-if="type === 'virtuoso'" name="virtuoso">
    <img src="@/assets/images/benefit/virtuoso_rate_icon.png" alt="" />
  </slot>
</template>

<script setup>
defineProps({
  type: {
    type: String
  }
});
</script>

<style lang="scss" scoped>
img {
  width: 24px;
  margin-bottom: 8px;
}
</style>
